import { render } from "./TransactionRow.vue?vue&type=template&id=d9d4731a&scoped=true"
import script from "./TransactionRow.vue?vue&type=script&lang=js"
export * from "./TransactionRow.vue?vue&type=script&lang=js"

import "./TransactionRow.vue?vue&type=style&index=0&id=d9d4731a&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9d4731a"]])

export default __exports__